import { render, staticRenderFns } from "./RealFriendMeetingRefundRejectPage.vue?vue&type=template&id=97cc68f4&scoped=true"
import script from "./RealFriendMeetingRefundRejectPage.vue?vue&type=script&lang=js"
export * from "./RealFriendMeetingRefundRejectPage.vue?vue&type=script&lang=js"
import style0 from "./RealFriendMeetingRefundRejectPage.vue?vue&type=style&index=0&id=97cc68f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cc68f4",
  null
  
)

export default component.exports